import React, { useEffect, useState } from "react";
import { Avatar, Button, Typography, Box } from '@material-ui/core/';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useParams } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";

import ChildrenLoading from "../../../components/ChildrenLoading";

import useStyles from "./EmailConfirmation.style";

const EmailConfirmation = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { token } = useParams();

    const [loading, setLoading] = useState(true);
    const [tokenValidationResult, setTokenValidationResult] = useState();

    useEffect(() => {
        const validateToken = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_EMAILCONFIRMATION}/${token}`)
                if (!response.ok) {
                    let json = await response.json();
                    setTokenValidationResult({ severity: 'error', message: json.message });
                    return;
                };
                setTokenValidationResult({ severity: 'success', message: t(`signUpEmailConfirmation.feedbackMessage.success`) });
            }
            catch (error) {
                setTokenValidationResult({ severity: 'error', message: error.message });
            } finally {
                setLoading(false);
            };
        };

        validateToken();
    }, [token, t]);

    if (loading) return <ChildrenLoading />

    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                {t('signUpEmailConfirmation.title')}
            </Typography>
            {tokenValidationResult &&
                <Alert severity={tokenValidationResult.severity}>{tokenValidationResult.message}</Alert>
            }
            <Box className={classes.buttonContainer}>
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    component={RouterLink}
                    to="/provider/login"
                >
                    {t('passwordRecovery.buttonLabels.login')}
                </Button>
            </Box>
        </div>
    )
};

export default EmailConfirmation;